import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { Languages } from "./translations/translations";
import LanguageDetector from 'i18next-browser-languagedetector';
// const options = {
//     order: ['navigator','querystring', 'cookie', 'localStorage', 'sessionStorage',  'htmlTag', 'path', 'subdomain'],
//     lookupQuerystring: 'lng'
// }
i18next
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
    detection: { order: ['navigator'] },
    // resources,
    fallbackLng: 'en',
});
Languages.forEach(function (i) {
    i18next.addResourceBundle(i.code, 'translation', i.resource);
});
